import { Component, OnInit, Input } from '@angular/core';
import { TextHelper } from 'src/app/utils/text-helper';
import { GenericResponse } from 'src/app/data/repository/generic-response';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';

@Component({
  selector: 'app-edit-height',
  templateUrl: './edit-height.component.html',
  styleUrls: ['./edit-height.component.scss'],
})
export class EditHeightComponent implements OnInit {
  @Input() height: string;
  hasError = false;

  constructor(
    private textHelper: TextHelper,
    private userApiService: UserApiService
  ) {}

  ngOnInit() {}

  save(): Promise<GenericResponse> {
    let response: GenericResponse;
    this.height = this.textHelper.replacePersian(this.height);
    if (!this.hasErrors()) {
      // console.log('saved', parseInt(this.height))
      return this.userApiService.editUser(
        null,
        null,
        null,
        null,
        parseInt(this.height)
      );
    } else {
      response = new GenericResponse(false);
      return Promise.resolve(response);
    }
  }

  checkActivatingButton() {
    this.hasError = false;
  }

  hasErrors() {
    if (this.height === '') {
      this.hasError = true;
      return true;
    }
    if (parseInt(this.height) < 100 || parseInt(this.height) > 250) {
      this.hasError = true;
      return true;
    }
    return false;
  }
}
